module.exports = __webpack_public_path__ + "media/assets/fonts/Gobold-Bold-3e7fc4fdce676f66f60c5e3f273cc966.otf";